import { BusinessSchema } from '@40seas/entities/businesses';
import { Buyer } from '@40seas/entities/buyers';
import { CastToNumber, CreditLineProvider, EnumSchema, Executor, ExecutorSchema, FromSchema, Replace } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import 'zod-openapi/extend';
import { CreditLineResult, CreditLineResultSchema } from './credit-line.result';

export const CreditLineSchema = WithBaseEntitySchema(
    z.object({
        buyer: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .or(BusinessSchema),
        requestedAmount: CastToNumber(z.number().gt(0, 'Requested amount must be greater than $0')).optional(),
        isActive: z.boolean(),
        currency: EnumSchema(Currency),
        result: CreditLineResultSchema,
        provider: EnumSchema(CreditLineProvider).optional(),
        availableCredit: CastToNumber(z.number()).optional().openapi({
            description: 'Computed field. The remaining credit available for this credit line. Cannot be used for aggregation.',
            readOnly: true,
            'x-computed': true,
        }),
        updatedBy: ExecutorSchema.optional(),
    }),
).strict();

export class CreditLine extends FromSchema(CreditLineSchema) implements BaseEntity {
    id: string;
    buyer: string | Buyer;
    requestedAmount?: number;
    currency?: Currency;
    result: CreditLineResult;
    isActive: boolean;
    availableCredit?: number;
    updatedBy?: Executor;
    seller: string | Seller;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    provider?: CreditLineProvider;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}

export class SupplierCreditLine extends Replace(CreditLine, [
    {
        fieldName: 'provider',
        newFieldSchema: EnumSchema([CreditLineProvider.Supplier]),
    },
]) {}
